import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03247408"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "manage_subscription__card !tw-mt-0" }
const _hoisted_2 = { class: "manage_subscription__card-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "manage_subscription__card-tag" }, "MONTHLY", -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "manage_subscription__card-details" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "manage_subscription__card-details__title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "£9.99"),
  /*#__PURE__*/_createElementVNode("p", null, "per month")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "manage_subscription__card-details__text" }, [
  /*#__PURE__*/_createElementVNode("ul", { class: "check-list" }, [
    /*#__PURE__*/_createElementVNode("li", { class: "check-list__item" }, "iknowa Verified Trade Passport"),
    /*#__PURE__*/_createElementVNode("li", { class: "check-list__item" }, "Access to subsidised courses"),
    /*#__PURE__*/_createElementVNode("li", { class: "check-list__item" }, " Store & manage documents (100 MB) "),
    /*#__PURE__*/_createElementVNode("li", { class: "check-list__item" }, " Access to residential & commercial jobs "),
    /*#__PURE__*/_createElementVNode("li", { class: "check-list__item" }, " Access to trade contractor network "),
    /*#__PURE__*/_createElementVNode("li", { class: "check-list__item" }, "Access tp collaboration tools"),
    /*#__PURE__*/_createElementVNode("li", { class: "check-list__item" }, "E-Wallet")
  ])
], -1))
const _hoisted_8 = { class: "bottom-btn" }
const _hoisted_9 = { class: "manage_subscription__card-header" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "manage_subscription__card-tag" }, "YEARLY", -1))
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "manage_subscription__card-details" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "manage_subscription__card-details__title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "£7.99"),
  /*#__PURE__*/_createElementVNode("p", null, "per month / £95.90 today")
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "manage_subscription__card-details__text" }, [
  /*#__PURE__*/_createElementVNode("ul", { class: "check-list" }, [
    /*#__PURE__*/_createElementVNode("li", { class: "check-list__item" }, "iknowa Verified Trade Passport"),
    /*#__PURE__*/_createElementVNode("li", { class: "check-list__item" }, "Access to subsidised courses"),
    /*#__PURE__*/_createElementVNode("li", { class: "check-list__item" }, " Store & manage documents (100 MB) "),
    /*#__PURE__*/_createElementVNode("li", { class: "check-list__item" }, " Access to residential & commercial jobs "),
    /*#__PURE__*/_createElementVNode("li", { class: "check-list__item" }, " Access to trade contractor network "),
    /*#__PURE__*/_createElementVNode("li", { class: "check-list__item" }, "Access tp collaboration tools"),
    /*#__PURE__*/_createElementVNode("li", { class: "check-list__item" }, "E-Wallet")
  ])
], -1))
const _hoisted_15 = { class: "bottom-btn" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "description explore__desc" }, " *T&C Apply. All rights reserved. ©iknowa 2024 ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_WizardModal = _resolveComponent("WizardModal")!

  return (_openBlock(), _createBlock(_component_WizardModal, {
    hideFooter: true,
    hideBackButton: true,
    singleData: $setup.modelDetails,
    onOnClose: _cache[2] || (_cache[2] = ($event: any) => ($setup.onClickToggleOccupierWelcome(false))),
    modelValue: $setup.isShowManageSubscription,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.isShowManageSubscription) = $event))
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_v_card, {
          class: _normalizeClass(["manage_subscription__card-item", $props.currentPlan === $setup.PaymentPlanType.MONTHLY ? 'selected' : ''])
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              ($props.currentPlan === $setup.PaymentPlanType.MONTHLY)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Current Plan"))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                ($props.currentPlan !== $setup.PaymentPlanType.MONTHLY)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      class: "button button-orange",
                      loading: 
                  $props.currentPlan === $setup.PaymentPlanType.MONTHLY ? false : $setup.isLoading
                ,
                      onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.onClickUpdatePlan($setup.PaymentPlanType.MONTHLY)))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("CHOOSE MONTHLY ")
                      ]),
                      _: 1
                    }, 8, ["loading"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_v_card, {
          class: _normalizeClass(["manage_subscription__card-item", $props.currentPlan === $setup.PaymentPlanType.YEARLY ? 'selected' : ''])
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              ($props.currentPlan === $setup.PaymentPlanType.YEARLY)
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Current Plan"))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _hoisted_14,
              _createElementVNode("div", _hoisted_15, [
                ($props.currentPlan !== $setup.PaymentPlanType.YEARLY)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      class: "button button-orange",
                      loading: 
                  $props.currentPlan === $setup.PaymentPlanType.YEARLY ? false : $setup.isLoading
                ,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.onClickUpdatePlan($setup.PaymentPlanType.YEARLY)))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("CHOOSE YEARLY")
                      ]),
                      _: 1
                    }, 8, ["loading"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      _hoisted_16
    ]),
    _: 1
  }, 8, ["singleData", "modelValue"]))
}